import { render, staticRenderFns } from "./CInsurerPicker.vue?vue&type=template&id=8706907c&"
import script from "./CInsurerPicker.vue?vue&type=script&lang=js&"
export * from "./CInsurerPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports